
// eslint-disable-next-line
//@ts-ignore
import FormControlInput from '@/components/general/FormControl/Input';

// eslint-disable-next-line
//@ts-ignore
import FormControlDatetime from '@/components/general/FormControl/Datetime';

import { Form as ValidationForm } from 'vee-validate';

import { defineComponent, watch, ref } from 'vue';
import { calendarStore } from '@/store/calendar-store';
import { useRoute } from 'vue-router';
import { Calendar } from '@fullcalendar/core';
import useHashParams from '@/composables/general/useHashParams';

export default defineComponent({
  name: 'Filter',
  props: {
    calendar: {
      type: Calendar,
      required: true,
    },
    cal_config: {
      type: Object,
      required: false,
    },
  },
  components: {
    FormControlInput,
    FormControlDatetime,
    ValidationForm,
  },
  setup(props) {
    const route = useRoute();
    const { setHashParams } = useHashParams(route);

    const filterText = ref();
    const startDate = ref();
    const endDate = ref();

    const firstDayofMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 2).toISOString().slice(0, 10);
    const lastDayofMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 32).toISOString().slice(0, 10);

    //methods
    const resetFilter = () => {
      startDate.value = firstDayofMonth;
      endDate.value = lastDayofMonth;
      filterText.value = '';

      setHashParams({
        cal_startDate: startDate.value,
        cal_endDate: endDate.value,
        cal_filterText: filterText.value,
      });

      calendarStore.setFilter({
        startDate: startDate.value,
        endDate: endDate.value,
        filterText: filterText.value,
      });

      calendarStore.toggleFilter();
      if (props.cal_config && props.cal_config.calendar_view) {
        props.calendar.changeView(props.cal_config.calendar_view);
      } else props.calendar.changeView('dayGridMonth');
    };

    const setFilteredEvents = (values: any) => {
      let startDate = '';
      let endDate = '';
      if (values.startDate) {
        startDate = values.startDate.toISOString().slice(0, 10);
      }
      if (values.endDate) {
        endDate = values.endDate.toISOString().slice(0, 10);
      }
      let filterText = '';
      if (values.filterText) {
        filterText = values.filterText;
      }
      setHashParams({
        cal_startDate: startDate,
        cal_endDate: endDate,
        cal_filterText: filterText,
      });
      calendarStore.setFilter({
        startDate: startDate,
        endDate: endDate,
        filterText: filterText,
      });
    };

    //update filter form
    watch(calendarStore.getState(), () => {
      startDate.value = calendarStore.getState().filter.startDate;
      endDate.value = calendarStore.getState().filter.endDate;
      filterText.value = calendarStore.getState().filter.filterText;
    });

    return {
      startDate,
      endDate,
      filterText,
      setFilteredEvents,
      resetFilter,
    };
  },
});
